export default {"src":"/_next/static/image/public/images/flags/flag_237.0c27b72b776b103b2aa83ef369167b1d.svg","height":16,"width":24};